<template>
  <div
    id="main-body"
    :class="{ [$route.query?.referrer ?? '']: true }"
    class="min-h-screen flex flex-col"
  >
    <PublicSiteNavBar v-if="!noBrandActive" />
    <ModalTender v-if="isNewTender && newTender.state.modalOpen" />
    <JoszakiToastContainer />
    <JoszakiAlert />
    <JoszakiConfirm />
    <FavouriteAuthDialog />
    <!-- NOTE: .container requires a left/right padding in order to avoid overflow-x on mobile -->
    <!-- NOTE: .py-5 equals with the .block bottom margin (we might refactor this globally in the future) -->
    <Nuxt class="min-h-[calc(100vh-50px)]" />
    <ProfessionDeepLinks v-if="!noBrandActive" />
    <ProfessionLinks
      v-if="!noBrandActive && $branding.hasFeature(FEATURES.PROFESSIONALS)"
    />
    <CityList
      v-if="!noBrandActive && $branding.hasFeature(FEATURES.PROFESSIONALS)"
    />
    <LogoSlogan v-if="!noBrandActive && !$branding.isPriceOffer" />
    <TheFooter v-if="!noBrandActive" />
    <!-- 
        TODO: fix this because it's throwing appendChild error in the production build, probably because isNewTenderException
        <PanelFloatTender
        v-if="
          isNewTender &&
          newTender.state.showFloater &&
          !newTender.isOpen.value &&
          !isNewTenderException
        "
      /> -->
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import { mapGetters } from "vuex";
import { mapState } from "pinia";
import { useAdminStore } from "~/stores/admin";
import CityList from "~/components/people/CityList.vue";
import LogoSlogan from "~/components/_refactored/footer/LogoSlogan.vue";
import ModalTender from "~/components/newTender/ModalTender.vue";
import JoszakiAlert from "~/components/joszaki/JoszakiAlert.vue";
import ProfessionLinks from "~/components/people/ProfessionLinks.vue";
import ProfessionDeepLinks from "~/components/_refactored/footer/ProfessionDeepLinks.vue";
import { useUserStore } from "~/stores/user";
import JoszakiToastContainer from "~/components/_refactored/common/JoszakiToastContainer.vue";
import PublicSiteNavBar from "~/components/_refactored/header/PublicSiteNavBar.vue";
import JoszakiConfirm from "~/components/joszaki/JoszakiConfirm.vue";
import FavouriteAuthDialog from "~/components/_refactored/favourite/FavouriteAuthDialog.vue";
import { useNewTender } from "~/composables/tender/useNewTender";
import TheFooter from "~/components/_refactored/TheFooter.vue";
import { useNoBrandActive } from "~/composables/useNoBrandActive";
import { FEATURES } from "~/config/pages/features.config";

export default defineComponent({
  components: {
    PublicSiteNavBar,
    CityList,
    LogoSlogan,
    ModalTender,
    JoszakiAlert,
    JoszakiToastContainer,
    JoszakiConfirm,
    FavouriteAuthDialog,
    TheFooter,
    ProfessionLinks,
    ProfessionDeepLinks,
  },
  setup() {
    const newTender = useNewTender();

    return {
      adminStore: useAdminStore(),
      newTender,
      noBrandActive: useNoBrandActive(),
      FEATURES,
    };
  },
  computed: {
    isNewTenderException() {
      const exceptions = ["prices"];
      const routeName = (this.$route.name ?? "").split("_")[0];
      return exceptions.includes(routeName);
    },
    ...mapState(useUserStore, {
      me: "me",
    }),
    selectedCity() {
      return this.$store.getters["search/city"];
    },
    ...mapGetters("listPage", {
      city: "city",
      profession: "profession",
      county: "county",
    }),
    isNewTender() {
      return (
        this.$ab.isVariant("new-tender-2", "variant1") ||
        this.$ab.isVariant("new-tender-2", "variant2")
      );
    },
  },
});
</script>
